import { Column } from '@ant-design/charts';
import { Tooltip } from '@material-ui/core';
import InfoIcon from '@mui/icons-material/Info';
import React from 'react';
import '../Chart.scss';
import { UTCGraphDisclaimerMessage } from '../../../constants/AnalyticsConst';

function CustomColumnChart(props) {
  const { data = [], title = null, xAxis = 'x', yAxis = 'y' } = props;

  const config = {
    data: data,
    xField: xAxis,
    yField: yAxis,
    // Temporarily hide the value that appears on the bar.
    // label: {
    //   text: (d) => d[yAxis],
    //   textBaseline: "bottom",
    // },
    style: {
      fill: ({ type }) => {
        return '#06D6A0';
      },
    },
    scale: {
      y: {
        domainMax:
          Number(data?.reduce((max, obj) => (obj[yAxis] > max ? obj[yAxis] : max), 0) || 0) + 20,
        domainMin: 0,
      },
    },
  };
  return (
    <div className='col-12 mw-100 mh-100 h-100 d-flex flex-column pb-1 px-1'>
      {title !== null && (
        <div className='analytic-header-wrapper title ps-2 pt-2 pb-1 d-flex align-items-center justify-content-between'>
          <span className='analytic-title'>{title}</span>
          <div>
            <Tooltip title={UTCGraphDisclaimerMessage} placement='right'>
              <InfoIcon style={{ fontSize: '15px' }} />
            </Tooltip>
          </div>
        </div>
      )}
      <div className='analytic-breaker' />
      <div className='chart-height mw-100'>
        <div className='h-100 w-100 mw-100 mh-100'>
          <Column {...config} />
        </div>
      </div>
    </div>
  );
}
export default CustomColumnChart;
